import { FeeLevelType } from '../../types/index';
import { getFeeLevel } from "actions/Utilities/FeeLevel";
import { useQuery } from "react-query";

export default function useFeeLevel() {
  //Fetching FeeLevel Details
  const {data, isFetching}= useQuery("GetFeeLevels", getFeeLevel, {
    refetchOnWindowFocus: false,
  });
  if(data){
    data.sort((a, b) => {
        let fa = a.feeLevelName.toLowerCase(), fb = b.feeLevelName.toLowerCase();
        return (fa < fb)?-1:(fa > fb?1:0);
    });
  }
  return {data: data as FeeLevelType[], isFetching};
}
